import { Box, styled, Typography } from '@mui/material';
import { ReactComponent as DealIcon } from 'assets/handshake-black.svg';
import { ReactComponent as LeadIcon } from 'assets/leads-icon-black.svg';
import { ReactComponent as TaskIcon } from 'assets/task-black.svg';

import { capitalizeStage } from 'components/featured/Deals/components/DealDetailsMain/utils';
import { ComponentType } from 'react';
import { Link } from 'react-router-dom';
import RoutePaths from 'routes/RoutePaths';
import zeplinColor from 'theme/Color';

export type QuickActionButtonVariantType = 'task' | 'deal' | 'lead';

const StyledLink = styled(Link)(() => ({
  border: 'none',
  backgroundColor: zeplinColor.Neutral1,
  cursor: 'pointer',
  height: '56px',
  width: '100%',
  gap: '12px',
  borderRadius: '56px',
  padding: '8px',
  textDecoration: 'none',
  color: zeplinColor.BasicBlack,

  display: 'flex',
  alignItems: 'center',

  ':hover': {
    backgroundColor: zeplinColor.Neutral3,
  },
}));

const ICON_MAP: Record<QuickActionButtonVariantType, ComponentType> = {
  task: TaskIcon,
  deal: DealIcon,
  lead: LeadIcon,
};

const ACTION_ROUTE: Record<QuickActionButtonVariantType, string> = {
  task: RoutePaths.Tasks,
  deal: RoutePaths.Deals,
  lead: RoutePaths.Leads,
};

const QuickActionButton = ({
  variant,
  handleCloseSearch,
}: {
  variant: QuickActionButtonVariantType;
  handleCloseSearch: () => void;
}) => {
  const Icon = ICON_MAP[variant];
  const path = ACTION_ROUTE[variant];

  return (
    <StyledLink
      to={path}
      state={{ modal: true }}
      onClick={(e) => {
        e.stopPropagation();
        handleCloseSearch();
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '40px',
          borderRadius: '20px',
          aspectRatio: '1/1',
          backgroundColor: zeplinColor.Neutral1,
          border: `1px solid ${zeplinColor.Neutral6}`,
        }}
      >
        <Icon />
      </Box>
      <Typography variant='responsiveButtonMedium'>Create {capitalizeStage(variant)}</Typography>
    </StyledLink>
  );
};

export default QuickActionButton;
